import type { ReactNode } from "react";
import { memo, useCallback, useMemo, useState } from "react";
import { DesktopOutlined, MobileOutlined } from "@ant-design/icons";
import ProCard from "@ant-design/pro-card";
import PreviewBaseItem from "./PreviewBaseItem";
import desktopPreviewBackground from "./images/mac-window.png";
import mobilePreviewBackground from "./images/iphone.png";
import mobileHorizontalPreviewBackground from "./images/iphone-horizontal.png";


interface IPreviewModal {
  html_file: string;
  disable_links: boolean;
}

const PreviewModeTabs = ({ html_file, disable_links = false }: IPreviewModal) => {

  if (disable_links) {
    const re = new RegExp("href(|=(\'|\")([^\"]+)(\'|\"))", "g");
    html_file = html_file.replace(re, "href=\"javascript:void(0)\" style=\"cursor:not-allowed\"");
    const targetReg = new RegExp("target=(\'|\")([^\"]+)(\'|\")", "g");
    html_file = html_file.replace(targetReg, "");
  }
  const renderedHtmlDesktopPreview = useMemo(
    () => (
      <PreviewBaseItem
        backgroundImage={desktopPreviewBackground}
        backgroundSize="992px auto"
        contentHeight={530}
        contentWidth={992}
        iframeHeight={'100%'}
        iframeWidth={992}
        iframeTop={30}
        srcDoc={html_file}
        title="desktop"
      />
    ),
    [html_file],
  );
  const renderedHtmlMobilePreview = useMemo(
    () => (
      <PreviewBaseItem
        backgroundImage={mobilePreviewBackground}
        contentWidth={405 - 40}
        contentHeight={815 - 40}
        iframeWidth={304}
        iframeHeight={552}
        iframeLeft={(405 - 40 - 304) / 2}
        iframeTop={(815 - 40 - 552) / 2}
        srcDoc={html_file}
        title="mobileVertical"
      />
    ),
    [html_file],
  );
  const renderedHtmlMobileHorizontalPreview = useMemo(
    () => (
      <PreviewBaseItem
        backgroundImage={mobileHorizontalPreviewBackground}
        contentHeight={405 - 40}
        contentWidth={815 - 40}
        iframeHeight={304}
        iframeWidth={552}
        iframeTop={(405 - 40 - 304) / 2}
        iframeLeft={(815 - 40 - 552) / 2}
        srcDoc={html_file}
        title="mobileHorizontal"
      />
    ),
    [html_file],
  );
  const renderTabIcon = useCallback(
    (icon: ReactNode, title: string, width: number, height: number) => {
      const innerText = `${title} (${width} x ${height})`;
      return (
        <>
          {icon} {innerText}
        </>
      );
    },
    [],
  );
  const [activeKey, setActiveKey] = useState("1");
  return (
    <>
    <ProCard tabs={{
        activeKey,
        onChange: (key) => {
          setActiveKey(key);
        },
      }}
    style={{
      paddingBottom: 0,
      width: "992px",
      margin: "0 auto"
      }}>
      <ProCard.TabPane
        tab={renderTabIcon(<DesktopOutlined />, "Desktop", 992, 500)}
        key="1"
      >
      </ProCard.TabPane>
      <ProCard.TabPane
        tab={renderTabIcon(<MobileOutlined />, "Mobile", 302, 552)}
        key="2"
      >
      </ProCard.TabPane>
      <ProCard.TabPane
        tab={renderTabIcon(<MobileOutlined />, "Mobile Horizontal", 552, 302)}
        key="3"
      >
      </ProCard.TabPane>
    </ProCard>
    {activeKey === "1" && renderedHtmlDesktopPreview}
    {activeKey === "2" && renderedHtmlMobilePreview}
    {activeKey === "3" && renderedHtmlMobileHorizontalPreview}
    </>
  );
};

export default memo(PreviewModeTabs);
